import * as React from 'react';
import { Col, Row } from 'reactstrap';
import Page from '../Page';
import SystemReports from '../feature/SystemReports';

const SystemGeneratedReports = (props: any) => {

    return (
        <React.Fragment>
            <Page>
                <Row>
                    <Col>
                        <SystemReports />
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default SystemGeneratedReports;